export default __webpack_public_path__ + "static/media/task_care_plan_icon.1b97d3fd.svg";